import Loading from '../../../components/Loading';
// NuevaCitaPage.tsx
import React from 'react';
import {useLocation} from 'react-router-dom';
import { usePOS } from '../../../context/POSContext';
import ReservasWorkspace from './ReservasWorkspace';
import PuntoDeVentaProducto from './PuntoDeVentaProducto';
import { X } from 'lucide-react';

const C = {
    primary: 'var(--ad-primary, #3564db)',
    secondary: 'var(--ad-secondary, #3564db)',
    secondaryLight: 'var(--ad-secondary, #92b1ed)',
};

const NuevaCitaPage: React.FC = () => {
    const location=useLocation();
    const requestedTab=new URLSearchParams(location.search).get('tab');
    const initialView=requestedTab==='recepcion'||requestedTab==='espacios'?requestedTab:'nueva';
    const { operadorActivo, sesionActiva, puntoDeVenta, sucursalId, cargandoSesion } = usePOS();
    // Pantalla de carga / sin sesión (heredada)
    if (cargandoSesion) return (
        <Loading text="Cargando información…"/>
    );
    if (!sesionActiva || !puntoDeVenta) return (
        <div style={{ display:'flex', height:'100%', background:'var(--ad-surface, #fff)', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'12px' }}>
            <div style={{ width:'56px', height:'56px', borderRadius:'16px', background:`color-mix(in srgb, ${C.primary} 6.27%, transparent)`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <X size={24} color={C.primary} />
            </div>
            <p style={{ fontSize:'1.1rem', fontWeight:'650', color:'var(--ad-ink, #0f172a)' }}>Sin sesión POS activa</p>
        </div>
    );

    if (!sucursalId) return null;

    // Solo un módulo habilitado
    if (puntoDeVenta.habilitar_citas) {
        return <ReservasWorkspace initialView={initialView} key={`${initialView}|${sucursalId}|${sesionActiva.id}|${puntoDeVenta.id}|${operadorActivo?.token ?? ""}`} />;
    }
    if (puntoDeVenta.habilitar_cafeteria) {
        return <PuntoDeVentaProducto sesionActiva={sesionActiva} puntoDeVenta={puntoDeVenta} operadorToken={operadorActivo?.token ?? null} />;
    }

    // Fallback
    return null;
};

export default NuevaCitaPage;


